var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("customer::customer-list::tag_batch_add"),
        visible: _vm.visiable,
        width: "600px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visiable = $event
        },
      },
    },
    [
      _c(
        "el-row",
        { staticStyle: { display: "flex", "margin-bottom": "20px" } },
        [
          _c("div", { staticStyle: { "white-space": "nowrap" } }, [
            _vm._v(_vm._s(_vm.$t("customer::customer-list::customer_name"))),
          ]),
          _c(
            "div",
            { staticStyle: { "margin-left": "10px" } },
            _vm._l(_vm.selectList, function (item, index) {
              return _c("span", { key: item.id }, [
                _vm._v(
                  " " + _vm._s(item.firstName + " " + item.lastName) + " "
                ),
                index < _vm.selectList.length - 1
                  ? _c("span", [_vm._v(",")])
                  : _vm._e(),
              ])
            }),
            0
          ),
        ]
      ),
      _c("el-row", { staticStyle: { display: "flex" } }, [
        _c("div", [
          _vm._v(" " + _vm._s(_vm.$t("customer::customer-list::tag")) + " "),
          _c("p", { staticClass: "tips" }, [
            _vm._v(_vm._s(_vm.$t("customer::customer-list::ten_limit"))),
          ]),
        ]),
        _c(
          "div",
          [
            _c(
              "el-select",
              {
                staticStyle: { "margin-left": "10px", width: "300px" },
                attrs: {
                  placeholder: _vm.$t("customer::customer-list::select_tag"),
                  multiple: "",
                  "collapse-tags": "",
                  "multiple-limit": 10,
                  "popper-append-to-body": false,
                },
                model: {
                  value: _vm.tags,
                  callback: function ($$v) {
                    _vm.tags = $$v
                  },
                  expression: "tags",
                },
              },
              _vm._l(_vm.tagList, function (item) {
                return _c("el-option", {
                  key: item.id,
                  attrs: { label: item.name, value: item.id },
                })
              }),
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.visiable = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("customer::customer-list::cancel")))]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.loading },
              on: { click: _vm.setTag },
            },
            [_vm._v(_vm._s(_vm.$t("customer::customer-list::confirm")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }